import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import { ChatComponent } from "../../components/chat/chat.component";
import { supabase } from "@/lib/supabase";
import { Logger } from "@/lib/logger/Logger";
import { AcceptJobRequestResult } from "../../store/Jobs/job.store";

interface VendorGeneralChatPageProps {
	organizationId: string;
	onShareFile: (fileId: string) => Promise<void>;
	onUnshareFile: (fileId: string) => Promise<void>;
	onAcceptJobRequest: (
		channelId: string | null
	) => Promise<AcceptJobRequestResult>;
	onDenyJobRequest: (channelId: string | null) => Promise<boolean>;
}

export const VendorGeneralChatPage: React.FC<VendorGeneralChatPageProps> = ({
	organizationId,
	onShareFile,
	onUnshareFile,
	onAcceptJobRequest,
	onDenyJobRequest,
}) => {
	const { vendorId } = useParams<{ vendorId: string }>();
	const [channelId, setChannelId] = useState<string | null>(null);

	useEffect(() => {
		if (!vendorId || !organizationId) return;

		supabase
			.rpc("get_or_create_general_channel", {
				p_vendor_org_id: vendorId,
				p_customer_org_id: organizationId,
			})
			.then(({ data, error }) => {
				if (error) {
					Logger.error(
						"Error getting/creating general channel",
						{},
						error
					);
					return;
				}
				if (data) {
					setChannelId(data);
				}
			});
	}, [vendorId, organizationId]);

	if (!channelId || !organizationId || !vendorId) {
		return <div></div>;
	}

	return (
		<div className="h-full w-full">
			<ChatComponent
				organizationId={organizationId}
				channelId={channelId}
				onShareFile={onShareFile}
				onUnshareFile={onUnshareFile}
				onAcceptJobRequest={onAcceptJobRequest}
				onDenyJobRequest={onDenyJobRequest}
				clientOrganizationIds={[vendorId]}
				allowGoTo={true}
				checkForClientConnectionToCustomer={false}
			/>
		</div>
	);
};
